const Inscripto = (props) => {
  const formato_cajon_visible = "flex flex-row justify-around my-1 visible"
  const formato_cajon_invisible = "flex flex-row justify-around my-1 invisible"
  const formato_data_visible = "flex flex-row justify-between visible"
  const formato_data_invisible = "flex flex-row justify-between invisible"

  const generar_QR = (() => {
    fetch(props.back + 'admin/armar_certificadoqr', {
      body: JSON.stringify(props.updData),
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + props.token, 'Content-Type': 'application/json' }
    })
      .then(response => response.json())
      .then(a => {
        console.log(a.resp)
        if (a.resp)
          window.open("https://inscripcion.ar/servicios/back_" + props.evento.tabla + "/tarjetas/" + props.evento.prefijoqr + props.updData.id + '.png')
      })
  })

  const comprobante = ((c) => {
    var imagen
    const cual = parseInt(c)
    switch (cual) {
      case 1: imagen = 'https://inscripcion.ar:8006/uploads/' + props.updData.imagen1
        break
      case 2: imagen = 'https://inscripcion.ar:8006/uploads/' + props.updData.imagen2
        break
      case 3: imagen = 'https://inscripcion.ar:8006/uploads/' + props.updData.imagen3
        break
    }
    window.open(imagen)
  }
  )


  const update = (() => {
    const aceptado = props.updData.aceptado === 'Si' ? true : false
    const a = { ...props.updData, aceptado: aceptado }
    var data = {
      body: JSON.stringify(a),
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + props.token, 'Content-Type': 'application/json' }
    }

    fetch(props.back + 'admin/corregir', data)
      .then(response => response.json())
      .then(json => {
        props.setPreinscriptos(props.preinscriptos.map(a => a.id === props.updData.id ? json : a))
        props.setUpdData({ id: 0 })
      })
  })



  return (<>
    <div className="border-2 border-gray-600 w-full my-1 px-2 flex flex-col mb-10 bg-zinc-400">
      <div className="flex flex-row justify-evenly my-1">
        <div className="flex flex-row justify-between">
          <label>Empresa</label>
          <input
            type="text"
            value={props.updData.empex}
            onChange={e => props.setUpdData({ ...props.updData, empex: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between">
          <label>Stand</label>
          <input
            type="text"
            value={props.updData.standnum}
            onChange={e => props.setUpdData({ ...props.updData, standnum: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between w-30">
          <label>Armador</label>
          <input
            type="text"
            value={props.updData.empar}
            onChange={e => props.setUpdData({ ...props.updData, empar: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between">
          <label>Contacto</label>
          <input
            type="text"
            value={props.updData.nombrecont}
            onChange={e => props.setUpdData({ ...props.updData, nombrecont: e.target.value })}
            className="ml-5"
          />
        </div>
      </div>
      <div className="flex flex-row justify-evenly my-1">
        <div className="flex flex-row justify-between">
          <label>Teléfono</label>
          <input
            type="text"
            value={props.updData.whatcont}
            onChange={e => props.setUpdData({ ...props.updData, whatcont: e.target.value })}
            className="ml-5"
          />
        </div>
        <div className="flex flex-row justify-between">
          <label>Aceptado</label>
          <select
            value={props.updData.aceptado ? 'Si' : 'No'}
            onChange={e => props.setUpdData({ ...props.updData, aceptado: e.target.value })}
            className="ml-5"
          >
            <option value='Si'>Si</option>
            <option value='No'>No</option>
          </select>
        </div>
        <div className={props.updData.id ? formato_data_visible : formato_data_invisible}>
          <label className="font-lg">{'ID:  ' + props.evento.prefijoqr + (props.updData.id).toString().padStart(4, '0')}</label>
        </div>
        {props.updData.cuando &&
          <div className={props.updData.id ? formato_data_visible : formato_data_invisible}>
            <label className="font-lg">Registrado el {props.updData.cuando.substr(0, props.updData.cuando.indexOf('T'))}</label>
            <label className="fornt-lg ml-3">A las  {props.updData.cuando.substr(props.updData.cuando.indexOf('T') + 1, 8)}</label>
          </div>
        }
      </div>
      <div className={props.updData.id ? formato_cajon_visible : formato_cajon_invisible}>
        <div className="flex flex-row items-center justify-between w-30">
          <label>Observaciones</label>
          <input
            type="text"
            value={props.updData.obs || ''}
            onChange={e => props.setUpdData({ ...props.updData, obs: e.target.value })}
            className="ml-5"
          />
        </div>

        <button
          name='imagen1'
          className="border-2 px-2 border-red-400 bg-red-200 text-sm hover:text-white hover:bg-red-800"
          onClick={() => comprobante(1)}
        >
          Listado
        </button>
        <button
          name='imagen2'
          className="border-2 px-2 border-red-400 bg-red-200 text-sm hover:text-white hover:bg-red-800"
          onClick={() => comprobante(2)}
        >
          ART 1
        </button>
        <button
          name='imagen3'
          className="border-2 px-2 border-red-400 bg-red-200 text-sm hover:text-white hover:bg-red-800"
          onClick={() => comprobante(3)}
        >
          ART 2
        </button>
        {(props.quien.rol === 2 || props.quien.permisos & 2) ?
          <button
            name='Aceptar'
            className="border-2 px-2 border-blue-400 bg-blue-200 text-sm hover:text-white hover:bg-blue-800"
            onClick={() => update()}
          >
            Guardar Cambios
          </button>
          : ''}
        {(props.quien.rol === 2 || props.quien.permisos & 16) ?
          <button
            name='Generar'
            className="border-2 px-2 border-green-400 bg-green-200 text-sm hover:text-white hover:bg-blue-800"
            onClick={e => generar_QR()}
          >
            Ver QR
          </button>
          : ''}
      </div>
    </div>
  </>)
}


export default Inscripto